import { ThemeModeSwitcher } from 'src/features/ThemeModeSwitcher'

import { useSettingToggleTheme } from './useSettingToggleTheme'

const SettingToggleTheme = (): JSX.Element => {
  const { themeLabel } = useSettingToggleTheme()

  return (
    <div className="flex flex-col mt-6 max-w-[250px]">
      <div className="flex items-center space-x-7">
        <span className="text-md font-medium w-[72%]">{themeLabel}</span>
        <ThemeModeSwitcher />
      </div>
    </div>
  )
}

export default SettingToggleTheme
